import { render, staticRenderFns } from "./xiaoweiList.vue?vue&type=template&id=5e9399db"
import script from "./xiaoweiList.vue?vue&type=script&lang=js"
export * from "./xiaoweiList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports